/* eslint-disable @typescript-eslint/naming-convention */
// necessary to disable due to API convention
import Head from 'next/head'
import Layout, { Breadcrumb } from 'components/layout'
import { Container, Link, Input, Button } from 'components/ui'
import { useForm } from 'react-hook-form'
import { emailRegex, onlyNumbersRegex, userNameRegex } from 'helpers/regex'
import React, { useState } from 'react'
import { AddressService } from 'modules/address/services'
import axios from 'axios'
import cn from 'classnames'
import Multiselect from 'components/ui/multiselect'
import { Item } from 'components/ui/multiselect/types'
import { useNotification } from 'hooks'
import { BrowserView } from 'react-device-detect'
import s from './seja-um-vendedor.module.css'

const farmerProductCategories =[
  { label: 'Antepastos', value: 'antepastos' },
  { label: 'Massas artesanais', value: 'massas-artesanais' },
  { label: 'Molhos e temperos', value: 'molhos-e-temperos' },
  { label: 'Hortifruti', value: 'hortifruti' },
  { label: 'Azeites e óleos', value: 'azeites-e-óleos' },
  { label: 'Cafés', value: 'cafés' },
  { label: 'Chá, infusões e solúveis', value: 'chá,-infusões-e-solúveis' },
  { label: 'Grãos e farinhas', value: 'grãos-e-farinhas' },
  { label: 'Padaria e confeitaria', value: 'padaria-e-confeitaria' },
  { label: 'Bebidas alcóolicas', value: 'bebidas-alcóolicas' },
  { label: 'Bebidas não alcóolicas', value: 'bebidas-não-alcóolicas' },
  { label: 'Artesanato uso pessoal', value: 'artesanato-uso-pessoal' },
  { label: 'Artesanato/decoração', value: 'artesanato/decoração' },
  { label: 'Cerâmica', value: 'cerâmica' },
  { label: 'Moda', value: 'moda' },
  { label: 'Cosméticos e cuidados pessoais', value: 'cosméticos-e-cuidados-pessoais' },
  { label: 'Material de limpeza', value: 'material-de-limpeza' },
  { label: 'Mudas de plantas', value: 'mudas-de-plantas' },
  { label: 'Outros', value: 'outros' },
]

function translateMessage(message: string) {
  switch (message.toLocaleLowerCase()) {
    case 'user email already exists':
      return 'Já existe uma conta cadastrada com este email.'
    default:
      return message
  }
}

// Novos dados dos planos: apenas informações atualizadas com mensalidades e comissões corretas
const plansData =[
  {
    id: 'tech',
    title: 'Fazendinha tech',
    monthly: {
      label: 'SEM MENSALIDADE',
      oldPrice: null,
      newPrice: null,
    },
    commission: {
      percentage: '12%',
      fixed: '+ R$ 0,90 por pedido',
    },
    features:[
      { title: '❖ Loja online', desc: '' },
      { title: '❖ Cadastro ilimitado de produtos', desc: '' },
      { title: '❖ Cadastro ilimitado de EXPERIÊNCIAS', desc: 'Venda de eventos, visitações, cursos, etc.' },
      { title: '❖ Tarifas pix, cartão de crédito e boleto', desc: 'inclusas' },
      {
        title: '❖ Programa de Afiliados',
        desc: '1º e único programa de afiliados em alimentos do Brasil! Comissione produtores de conteúdo pela divulgação dos seus produtos. Eles terão acesso a uma pagina na Fazendinha com os produtos indicados, link personalizado e acompanhamento dos resultados.',
      },
      {
        title: '❖ Integração logística nacional',
        desc: 'Logística para envio a distância de produtos que não demandam refrigeração ou perecíveis. A cada pedido o sistema gera etiqueta de despacho. Deixe a encomenda em um posto mais próximo do seu endereço. Não há custo adicional de frete para quem vende.',
      },
      {
        title: '❖ Logística local',
        desc: 'Realizada pelo próprio produtor, que define a(s) cidade(s) atendidas. O valor recebido de frete pelo sistema é creditado ao parceiro junto as vendas.',
      },
    ],
  },
  {
    id: 'tech-plus',
    title: 'Fazendinha tech+plus',
    monthly: {
      label: 'MENSALIDADE',
      oldPrice: 'R$ 189,00',
      newPrice: 'R$ 99,00',
    },
    commission: {
      percentage: '8,90%',
      fixed: '+ R$ 0,90 por pedido',
    },
    features:[
      { title: 'Tudo do plano tech', desc: '' },
      {
        title: '+ FazendinhaLOG',
        desc: 'Acesso ao software de rotas integrado aos pedidos realizados, gerando automaticamente as rotas de acordo com o numero de veículos ou limitação de cada veículo, otimizando custos e tempo.',
      },
      {
        title: '+ Integração com parceiros de logística local',
        desc: 'Serviço opcional para o produtor. Valor a pagar calculado por km e pontos de entrega. Consulte disponibilidade na sua cidade e disponibilidade de veículos refrigerados.',
      },
      {
        title: '+ Fazendinha Fácil Mercadinho',
        desc: 'Abra seu próprio mercadinho no estilo honest market para vender em pontos offline. Gestão de vendas e estoque ponto por ponto integrados à loja na Fazendinha em Casa. Mercadinhos adicionais: 49,00/mês.',
      },
      {
        title: '+ FazendinhaChat',
        desc: 'Whatsapp automatizado p/ atendimento e vendas no número do produtor – Créditos Meta não inclusos',
      },
      {
        title: '+ link da loja personalizado',
        desc: 'Link personalizado da sua loja para mais fácil divulgação. Ex.: www.fazendinha.me/sualoja',
      },
    ],
  },
  {
    id: 'tech-ads',
    title: 'Fazendinha tech+ads',
    monthly: {
      label: 'MENSALIDADE',
      oldPrice: 'R$ 399,00',
      newPrice: 'R$ 299,00',
    },
    commission: {
      percentage: '6,90%',
      fixed: '+ R$ 0,90 por pedido',
    },
    features:[
      { title: 'Tudo do plano tech plus', desc: '' },
      {
        title: '+ Gestão do comercial b2b',
        desc: 'Gestão da carteira de clientes de atacado, gestão dos pedidos, relacionamento para vendas e pós-vendas com clientes ativos e inativos.',
      },
      {
        title: '+ Ads- Captação de novos clientes',
        desc: 'Planejamento e gestão de Ads whatsapp e E-mail marketing – Criação e disparos sob orçamento - Créditos Meta não inclusos.',
      },
      {
        title: '+ Produção de conteúdo',
        desc: 'Incluso: 02 postagens mensais para redes sociais e 01 postagem bimestral para blog. Criação de conteúdos adicionais: sob orçamento',
      },
      {
        title: '+ Serviços de identidade visual',
        desc: 'Desenvolvimento de logomarcas, rótulos, embalagens (sob orçamento)',
      },
    ],
  },
]

export default function SejaUmVendedor() {
  const crums =[
    {
      label: 'Institucional',
    },
  ]

  const [cityId, setCityId] = useState(0)
  const [selectedItems, setSelected] = useState<Item[]>([])
  const[done, setDone] = useState(false)
  const [expandedPlan, setExpandedPlan] = useState<string | null>(null)
  const { notify } = useNotification()

  const {
    register,
    handleSubmit,
    getValues,
    setValue,
    setError,
    formState: { errors, touched, isSubmitting },
  } = useForm({
    mode: 'all',
    reValidateMode: 'onSubmit',
  })

  const addressService = new AddressService()

  const togglePlan = (id: string) => {
    setExpandedPlan(expandedPlan === id ? null : id)
  }

  async function handleZipcode() {
    const value = getValues().address.zipcode.replace(/\D/g, '')
    try {
      const request = await addressService.getAddressByZipcode(value)

      const {
        city_id,
        viacep: { bairro, logradouro, localidade },
      } = request.data

      setCityId(city_id)
      setValue('address.street', logradouro)
      setValue('address.neighborhood', bairro)
      setValue('address.city_id', localidade)
    } catch (e) {
      setError('address.zipcode', { message: 'CEP não encontrado' })
    }
  }

  async function handleFormSubmit(values: any) {
    if (selectedItems.length <= 0) {
      notify({
        type: 'danger',
        title: 'Preencha todos os campos',
        description: 'Selecione ao menos um tipo de produto',
      })
      return
    }

    const formData = values

    const payload = {
      ...formData,
      address: {
        ...formData.address,
        cidade: formData.address.city_id,
        city_id: cityId,
      },
      estrada_real: false,
      company_email: formData.login_email,
      company_segment: selectedItems.map((object) => object.label),
    }

    try {
      const saveInfo = await axios.post('https://api.fazendinha.me/farmers', payload, {
        validateStatus: (status: any) => status >= 200 && status < 500,
      })
      if (saveInfo.status === 200) {
        setDone(true)
      } else {
        notify({ title: translateMessage(saveInfo.data.message), type: 'danger' })
      }
    } catch (error) {
      notify({ title: 'E-mail ou documento já está cadastrado.', description: 'Tente outro', type: 'danger' })
    }
  }

  if (done) {
    return (
      <Layout>
        <Head>
          <title>Seja um vendedor na Fazendinha em Casa</title>
        </Head>
        <Breadcrumb crumbs={crums} />
        <Container className={s.root}>
          <div className={s.center}>
            <h1 className={s.title}>Seu cadastro foi enviado com sucesso!</h1>
            <p>Aguarde informações por e-mail.</p>
            <br />
            <Button href="/">Ir para a home</Button>
          </div>
        </Container>
      </Layout>
    )
  }

  return (
    <Layout>
      <Head>
        <title>Seja um vendedor na Fazendinha em Casa</title>
      </Head>
      <Breadcrumb crumbs={crums} />
      <div className={s.seja_um_vendedor}>
        <Container className={s.root}>
          <div className={s.top_banner}>
            <img src="/assets/images/quero-vender/top.jpg" alt="" />
          </div>
          <nav className={s.nav}>
            <ul>
              <li>TRANSPARÊNCIA</li>
              <li>AUTONOMIA DO PRODUTOR</li>
              <li>TECNOLOGIA</li>
              <li>GESTÃO</li>
            </ul>
          </nav>
          <h1 className={s.text__h1}>
            Transforme o futuro em presente! A revolução do seu negócio passa pela Fazendinha em Casa!
          </h1>
          <div className={s.top__text}>
            <p>Em uma única plataforma, em constante evolução,</p>
            <p>você define as ferramentas e canais pelos quais quer disponibilizar seus produtos e
              serviços e acompanha os resultados em tempo real.</p>
          </div>
          <div className={s.top_banner}>
            <img src="/assets/images/quero-vender/middle.jpg" alt="" />
          </div>
          <h2 className={s.text__h1}>
            Valorize o seu tempo utilizando tecnologias que otimizam seus processos de comercialização, controle
            financeiro e logística.
          </h2>
          <div className={s.top__text}>
            <p>Na Fazendinha em Casa o produtor tem:</p>
            <ul className={s.diferencial}>
              <li>Loja personalizada para e-commerce</li>
              <li>Cadastro ilimitados de produtos.</li>
              <li>Venda a varejo ou por atacado</li>
              <li>
                Venda de Produtos e também{' '}
                <Link href="/experiencias" passHref>
                  Experiências
                </Link>
              </li>
              <li>Gestão em tempo real</li>
              <li>Integração com meios de pagamentos</li>
              <li>Gestão de vendas e financeira.</li>
              <li>Endereço da loja personalizado (www.fazendinha.me/sualoja)</li>
            </ul>
          </div>

          <h1 className={s.text__h1} style={{ marginBottom: '0' }}>
            Comissões e taxas
          </h1>
          <p style={{ textAlign: 'center' }}>
            <strong>(Inclusas tarifas de cartão de crédito, boleto e PIX)</strong>
          </p>
          <br />

          {/* ======== INÍCIO DA TABELA DE COMISSÕES ========= */}
          <div className={s.comissao__table}>
            <div className={`hidden md:flex ${s.comissao__row}`}>
              <div className={s.comissao__col}>Planos</div>
              <div className={s.comissao__col}>Mensalidade</div>
              <div className={s.comissao__percentage}>Comissões</div>
            </div>

            {plansData.map((plan) => {
              const isExpanded = expandedPlan === plan.id;

              return (
                <div key={plan.id} className={s.comissao__row_wrapper}>
                  <div
                    className={s.comissao__row}
                    onClick={() => togglePlan(plan.id)}
                    style={{ cursor: plan.features.length > 0 ? 'pointer' : 'default' }}
                  >
                    {/* COLUNA 1: NOME DO PLANO */}
                    <div className={s.comissao__plan}>
                      <span>Plano</span>
                      <h3>{plan.title}</h3>
                    </div>

                    {/* COLUNA 2: MENSALIDADE */}
                    <div className={s.comissao__col}>
                      <div className="flex flex-col items-start pl-4 md:pl-0">
                        {plan.monthly.oldPrice ? (
                          <>
                            <div className="text-xs font-bold text-gray-500 uppercase md:text-sm">{plan.monthly.label}</div>
                            <div className="flex items-center mt-1 space-x-2">
                              <s className="text-sm text-red-500 md:text-base">{plan.monthly.oldPrice}</s>
                              <span className="text-lg font-bold md:text-xl text-primary">{plan.monthly.newPrice}</span>
                            </div>
                          </>
                        ) : (
                          <div className="text-lg font-bold text-green-600 uppercase md:text-xl">
                            {plan.monthly.label}
                          </div>
                        )}
                      </div>
                    </div>

                    {/* COLUNA 3: COMISSÕES */}
                    <div className={s.comissao__percentage}>
                      <span className="block text-xs font-semibold text-gray-500 uppercase md:hidden">Comissão</span>
                      <h2>{plan.commission.percentage}</h2>
                      <p>{plan.commission.fixed}</p>
                    </div>

                    {/* BOTÃO EXPANDIR */}
                    {plan.features.length > 0 && (
                      <button className={s.comissao__expand_icon}>
                        {isExpanded ? 'Ocultar ▲' : 'Detalhes ▼'}
                      </button>
                    )}
                  </div>

                  {/* CONTEÚDO EXPANDIDO (FEATURES) */}
                  {isExpanded && plan.features.length > 0 && (
                    <div className={s.comissao__expanded_content}>
                      <h4 className={s.comissao__expanded_title}>O que está incluso:</h4>
                      <div className={s.comissao__features_grid}>
                        {plan.features.map((feat, idx) => (
                          <div key={idx} className={s.comissao__feature_item}>
                            <strong>{feat.title}</strong>
                            {feat.desc && <p>{feat.desc}</p>}
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
          {/* ======== FIM DA TABELA DE COMISSÕES ========= */}

          <div className={s.top_banner}>
            <img src="/assets/images/quero-vender/bottom.jpg" alt="" />
          </div>
          <br />
          <div className={s.bottom__text}>
            <p>
              Junte-se a todos que possuem os mesmos propósitos que o seu: a valorização da produção artesanal, local e
              saudável de alimentos. Venha cultivar um mundo melhor!
            </p>
          </div>

          <form onSubmit={handleSubmit(handleFormSubmit)} className={s.form} autoComplete="off">
            <Input
              type="text"
              name="company_name"
              placeholder="Nome da loja/marca/fazenda"
              disabled={isSubmitting}
              error={errors?.company_name?.message}
              touched={touched?.company_name}
              label="Nome da loja/marca/fazenda"
              ref={register({
                required: {
                  value: true,
                  message: 'Por favor, preencha o nome da loja/marca/fazenda no campo acima',
                },
                pattern: {
                  value: userNameRegex,
                  message: 'Apenas letras é permitido',
                },
                minLength: {
                  value: 5,
                  message: 'Ao menos 5 (cinco) caracteres',
                },
              })}
            />
            <Input
              type="text"
              name="company_responsible_name"
              placeholder="Nome completo do proprietário"
              label="Nome completo do proprietário"
              disabled={isSubmitting}
              error={errors?.company_responsible_name?.message}
              touched={touched?.company_responsible_name}
              ref={register({
                required: {
                  value: true,
                  message: 'Por favor, preencha o nome completo do proprietário no campo acima',
                },
                pattern: {
                  value: userNameRegex,
                  message: 'Apenas letras é permitido',
                },
                minLength: {
                  value: 5,
                  message: 'Ao menos 5 (cinco) caracteres',
                },
              })}
            />
            <Input
              type="tel"
              name="company_document"
              label="CNPJ (caso não possua CNPJ cadastre o seu CPF)"
              placeholder="CNPJ (caso não possua CNPJ cadastre o seu CPF)"
              disabled={isSubmitting}
              error={errors?.company_document?.message}
              touched={touched?.company_document}
              minLength={11}
              ref={register({
                required: {
                  value: true,
                  message: 'Por favor, preencha seu o CNPJ/CPF no campo acima',
                },
                pattern: {
                  value: onlyNumbersRegex,
                  message: 'Apenas números são permitidos',
                },
                minLength: {
                  value: 11,
                  message: 'Ao menos 11 (onze) caracteres',
                },
              })}
            />
            <Input
              type="email"
              name="login_email"
              placeholder="E-mail para login na plataforma"
              label="E-mail"
              disabled={isSubmitting}
              error={errors?.login_email?.message}
              touched={touched?.login_email}
              ref={register({
                required: {
                  value: true,
                  message: 'Por favor, preencha seu e-mail',
                },
                pattern: {
                  value: emailRegex,
                  message: 'E-mail inválido',
                },
              })}
            />
            <div className={s.form__row}>
              <Input
                type="password"
                name="login_password"
                placeholder="&bull;&bull;&bull;&bull;&bull;&bull;&bull;"
                label="Senha"
                error={errors?.login_password?.message}
                touched={touched?.login_password}
                ref={register({
                  required: {
                    value: true,
                    message: 'Por favor, preencha a senha',
                  },
                  minLength: {
                    value: 8,
                    message: 'No mínimo 8 (oito) caracteres',
                  },
                  validate: {
                    matchesNextPassword: (value) => {
                      const { confirmPassword } = getValues()
                      if (confirmPassword) {
                        return confirmPassword !== value ? 'A senha precisa ser igual' : true
                      }
                      return true
                    },
                  },
                })}
              />

              <Input
                type="password"
                name="confirmPassword"
                placeholder="&bull;&bull;&bull;&bull;&bull;&bull;&bull;"
                label="Confirme a senha"
                error={errors?.confirmPassword?.message}
                touched={touched?.confirmPassword}
                disabled={isSubmitting}
                ref={register({
                  required: {
                    value: true,
                    message: 'Confirme a senha',
                  },
                  minLength: {
                    value: 8,
                    message: 'No mínimo 8 (oito) caracteres',
                  },
                  validate: {
                    matchesPreviousPassword: (value) => {
                      const { login_password } = getValues()
                      return login_password !== value ? 'A senha precisa ser igual' : true
                    },
                  },
                })}
              />
            </div>
            <Input
              type="tel"
              name="address.zipcode"
              placeholder="CEP"
              label="CEP"
              error={errors?.address?.zipcode?.message}
              touched={touched?.address?.zipcode}
              disabled={isSubmitting}
              maxLength={8}
              onBlur={handleZipcode}
              ref={register({
                required: {
                  value: true,
                  message: 'Informe o CEP',
                },
                minLength: {
                  value: 8,
                  message: 'CEP inválido',
                },
              })}
            />
            <div className={s.form__row}>
              <Input
                type="text"
                name="address.street"
                placeholder="Rua"
                label="Rua"
                error={errors?.address?.street?.message}
                touched={touched?.address?.street}
                disabled={isSubmitting}
                maxLength={120}
                ref={register({
                  required: {
                    value: true,
                    message: 'Informe a rua',
                  },
                  minLength: {
                    value: 3,
                    message: 'Digite um nome maior que 3 caracteres',
                  },
                })}
              />
              <Input
                type="tel"
                name="address.number"
                placeholder="Número"
                label="Número"
                error={errors?.address?.number?.message}
                touched={touched?.address?.number}
                disabled={isSubmitting}
                maxLength={8}
                ref={register({
                  required: {
                    value: true,
                    message: 'Informe o número',
                  },
                })}
              />
            </div>
            <Input
              type="text"
              name="address.complement"
              placeholder="Complemento"
              error={errors?.address?.complement?.message}
              touched={touched?.address?.complement}
              disabled={isSubmitting}
              label="Complemento"
              maxLength={80}
              ref={register({
                minLength: {
                  value: 2,
                  message: 'Digite um complemento maior que 2 caracteres',
                },
              })}
            />
            <Input
              type="text"
              name="address.neighborhood"
              placeholder="Bairro"
              label="Bairro"
              error={errors?.address?.neighborhood?.message}
              touched={touched?.address?.neighborhood}
              disabled={isSubmitting}
              ref={register({
                required: {
                  value: true,
                  message: 'Informe o bairro',
                },
              })}
            />
            <Input
              type="tel"
              name="address.city_id"
              placeholder="Cidade"
              label="Cidade"
              error={errors?.address?.city_id?.message}
              touched={touched?.address?.city_id}
              disabled={isSubmitting}
              maxLength={8}
              ref={register({
                required: {
                  value: true,
                  message: 'Informe o CEP',
                },
              })}
            />
            <Input
              type="tel"
              name="address.phone"
              placeholder="Telefone"
              label="Telefone"
              error={errors?.address?.phone?.message}
              touched={touched?.address?.phone}
              disabled={isSubmitting}
              ref={register({
                required: {
                  value: true,
                  message: 'Informe o telefone de contato',
                },
                minLength: {
                  value: 8,
                  message: 'Número inválido',
                },
              })}
            />
            <div>Tipo de produto</div>
            <Multiselect
              selectedItems={selectedItems}
              setSelectedItems={setSelected}
              options={farmerProductCategories}
            />
            <Input
              type="text"
              name="instagram"
              label="Instagram"
              placeholder="Perfil do seu negócio no Instagram"
              error={errors?.instagram?.message}
              touched={touched?.instagram}
              disabled={isSubmitting}
            />
            <Input
              type="text"
              name="facebook"
              label="Facebook"
              placeholder="Perfil do seu negócio no Facebook"
              error={errors?.facebook?.message}
              touched={touched?.facebook}
              disabled={isSubmitting}
            />
            <Button type="submit" disabled={isSubmitting} variant="primary" loading={isSubmitting} className={s.button}>
              Enviar
            </Button>
          </form>
          <p className={s.text}>
            <span>
              <strong>Atendimento pelo Whatsapp</strong>
            </span>
            : (31) 98567.3191 (Seg. à sexta das 9h às 18h)
          </p>
          Leia também: <Link href="/termos-e-condicoes-para-vendedores">Termos e Condições para Vendedores</Link>
        </Container>
      </div>
    </Layout>
  )
}